import { render } from "./Wheel.vue?vue&type=template&id=5f00d2d2&scoped=true"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"

import "./Wheel.vue?vue&type=style&index=0&id=5f00d2d2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f00d2d2"]])

export default __exports__